import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { VehicleTypeForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditVehicleType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const vehicletype = useSelector((state) => state.vehicletype);
  const [wheel, setWheel] = React.useState(vehicletype?.wheel);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: vehicletype.name,
      description: vehicletype.description,
      type_code: vehicletype.type_code,
    },
  });

  useEffect(() => {
    dispatch(actions.vehicletypeGet(id));
    return () => {};
  }, []);

  useEffect(() => {
    setWheel(vehicletype?.wheel);
    return () => {};
  }, [vehicletype]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      const dataSubmit = {
        ...data,
        wheel,
      };
      console.log(dataSubmit);
      await dispatch(actions.vehicletypePut(id, dataSubmit));
      await dispatch(actions.vehicletypeGet(id));
      alert('สำเร็จ');
    } catch (error) {
      console.log(error);
    }
  };
  if (vehicletype.isLoading || vehicletype.rows) {
    return <Loading />;
  }
  if (!vehicletype.isLoading && vehicletype.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <VehicleTypeForm
                errors={errors}
                vehicletype={vehicletype}
                control={control}
                Controller={Controller}
                wheel={wheel}
                setWheel={setWheel}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
EditVehicleType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditVehicleType.defaultProps = {
  title: '',
  subtitle: '',
};
